export default __webpack_public_path__ + "assets/certificates/CE-MR.206d6959.pdf";